import { EnvironmentNames } from '../../lib/_core/constants/environments';
import { environment as swissEnv } from '../swiss/environment.swiss-prod';

export const environment = {
  fund: {
    primaryColor: 'rgb(26, 62, 112)',
    secondaryColor: 'rgb(226,223,223)',
    ternaryColor: 'rgb(155, 28, 35)',
    logo: 'assets/logos/sinngeber-white-bg.jpg',
    publicLogo: 'assets/logos/sinngeber-white-bg.jpg',
    lightDonateNowButtonLink: 'https://tbportal-prod-eucen2-assets.s3.eu-central-2.amazonaws.com/sgh/DE_SINNGEBER-1.png',
    darkDonateNowButtonLink: 'https://tbportal-prod-eucen2-assets.s3.eu-central-2.amazonaws.com/sgh/DE_SINNGEBER-2.png',
    lightDonateNowButtonSrc: 'assets/donate-buttons/sinngeber-light.png',
    darkDonateNowButtonSrc: 'assets/donate-buttons/sinngeber-dark.png',
    favicon: 'assets/favicon/sinngeber_g_gold.png',
    wiringInstructions: null,
    eftInstructions: null,
    stripeKey: 'pk_live_BeGJ1FRLlqpcO1fydyUZJUh0',
    homeLink: 'https://www.giving-fund.de',
    contact: 'giving-fund@sinngeber.eu',
    blog: '',
    privacyPolicy: '',
    terms: '',
    mailTo: 'giving-fund@sinngeber.eu',
    name: 'Sinngeber',
    tenantId: 'sinngeber',
    server: 'https://portal.giving-fund.de/api',
    url: 'https://portal.giving-fund.de',
    gsUrl: 'https://givingspace.trustbridgeglobal.com/',
    environmentName: EnvironmentNames.SINNGEBER,
    languages: ['sinngeber/de-sinngeber'],
    production: true,
    multiCurrency: false,
    redirectSourceUrl: swissEnv.fund.url,
    signatureApiKey: '82dbebd7-6b9f-4d06-ba49-f320cec3bae8',
  },
};
